import { Observable } from 'rxjs';
import { Rpc } from '../rpc';
import { RpcObservableClient } from '../rpc-observable-client';
import {
    RpcObservableElevateError, RpcObservableElevateKey, RpcObservableElevateRequest, RpcObservableElevateResult
} from './rpc-observable-elevate-model';

export class RpcObservableElevateClient
    extends RpcObservableClient<RpcObservableElevateRequest, RpcObservableElevateResult, RpcObservableElevateError>  {

    /**
     * Initializes a new instance of the RpcObservableElevateClient class.
     *
     * @param rpc the rpc object.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcObservableElevateKey.command, RpcObservableElevateKey.version);
    }

    /**
     * The Elevate command.
     *
     * @return Observable<RpcObservableElevateResult> the observable object.
     */
    public elevate(): Observable<RpcObservableElevateResult> {
        return this.observableCall({});
    }
}
